/**
 * Store de autenticación. Persiste tokens y usuario en localStorage.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { LoginResponse, User } from "./api/types";

interface AuthState {
    user: User | null;
    accessToken: string | null;
    refreshToken: string | null;
    setSession: (data: LoginResponse) => void;
    refresh: () => Promise<boolean>;
    logout: () => void;
}

const BASE = import.meta.env.VITE_API_URL ?? "/api";

export const useAuth = create<AuthState>()(
    persist(
        (set, get) => ({
            user: null,
            accessToken: null,
            refreshToken: null,
            setSession: (data) =>
                set({ user: data.user, accessToken: data.access_token, refreshToken: data.refresh_token }),
            refresh: async () => {
                const rt = get().refreshToken;
                if (!rt) return false;
                try {
                    const res = await fetch(`${BASE}/auth/refresh`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ refresh_token: rt }),
                    });
                    if (!res.ok) return false;
                    const data = await res.json();
                    set({ accessToken: data.access_token, refreshToken: data.refresh_token });
                    return true;
                } catch {
                    return false;
                }
            },
            logout: () => {
                const rt = get().refreshToken;
                if (rt) {
                    fetch(`${BASE}/auth/logout`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ refresh_token: rt }),
                    }).catch(() => {});
                }
                set({ user: null, accessToken: null, refreshToken: null });
                // Volver a la landing al cerrar sesión
                window.location.href = "/";
            },
        }),
        { name: "certipol-auth" }
    )
);
